import http from "../helpers/http";

export const createUser = async (payload) => {
    const response = await http().post("/User/CreateUser", payload);
    return response.data;
};

export const completeCreateUser = async (payload) => {
    const response = await http().post("/User/CompleteCreateUser", payload);
    return response.data;
}

export const getUsers = async () => {
    const response = await http().get("/User/GetUsers");
    return response.data;
}

export const enableUser = async (userId) => {
    const response = await http().get(`/User/EnableUser/${userId}`);
    return response.data;
}

export const disableUser = async (userId) => {
    const response = await http().get(`/User/DisableUser/${userId}`);
    return response.data;
}

export const getUserById = async (userId) => {
    const response = await http().get(`/User/GetUserById/${userId}`);
    return response.data;
}

export const updateUser = async (payload) => {
    const response = await http().post("/User/UpdateUser", payload);
    return response.data;
};

